import React, { useState, useEffect } from "react";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import axios from "axios"
import Modal from 'react-bootstrap/Modal'
import TimeAgo from 'react-timeago'
import frenchStrings from 'react-timeago/lib/language-strings/en'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import GetRating from './getrating';
import ScrollAnimation from "react-animate-on-scroll";

import { inViewOptions } from '../Components/utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import { ElfsightWidget } from 'react-elfsight-widget';
const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const postsPerPage = 18;
let arrayForHoldingPosts = [];

const Ethics = (props) => {
    /**** set here local states */
    const [] = useState(0);

    const [postsToShow, setPostsToShow] = useState([]);
    const [next, setNext] = useState(18);

    const [] = useState(true);
    const [testimonials, setTestimonials] = useState([])

    const loopWithSlice = (start, end) => {
        const slicedPosts = testimonials.slice(start, end);
        arrayForHoldingPosts = [...arrayForHoldingPosts, ...slicedPosts];
        setPostsToShow(arrayForHoldingPosts);
    };

    const handleShowMorePosts = () => {
        loopWithSlice(next, next + postsPerPage);
        setNext(next + postsPerPage);
    };



    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [reviewid, setReviewid] = useState(false);
    const formatter = buildFormatter(frenchStrings)
    const handleShow = (event) => {
        setReviewid(event);
        setShow(true);
    }
    const getitems = async url => {
        try {
            const { data } = await axios.get(url, {
                headers: {
                Authorization: `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
                }
            })// could be from env files
            setTestimonials(data)
        } catch (error) {
            // cache it if fail/error;
            console.error(error)
        }
    }
    useEffect(() => {
        loopWithSlice(0, postsPerPage);
    }, [testimonials]);

    useEffect(() => {
        let url = `${process.env.GATSBY_STRAPI_SRC}/google-review-reviews`
        getitems(url);
    }, [])

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <section className="review-listing">
                        <React.Fragment>
                            <Container>
                                <ElfsightWidget widgetId="dee01cec-99e2-4821-9a6a-ff88c2554da6" lazy />;
                            </Container>
                        </React.Fragment>
                    </section>
                </motion.section>
            )}
        </InView>
    )
}
export default Ethics;